import { BluePredicatenIcon, isMobile, ProductLogo, sendCustomEvent } from '@kizi/comparator-components';
import { useField } from '@kizi/comparator-core';
import { Button, Div } from '@kizi/core-components';

import React from 'react';
import { ProductCardMainSection } from './components/ProductCardMainSection';
import { Price } from './components/Price';
import { Checkbox } from '@kizi/shared-components';
import { NonPurchasableText } from './components/NonPurchasableText';
import { InternetAndChannels } from './components/InternetAndChannels';

export const ProductCardTriplePlayTopThree = ({
  data,
  handleSubmit,
  TopThreeHealthBadgeComponent,
  onCompareChange,
  productTypes,
}) => {
  const currentProviderField = useField('startWidget.currentProvider');

  const { purchasableProduct, image, priceInfo, usps, tags, customAttributes } = data;

  const typeMappings = {
    highestRating: 'Hoogste testoordeel',
    fastestSpeed: 'Snelste',
    lowestPrice: 'Goedkoopste',
  }

  const { discountIncluded, initial: priceInitialValue, provider } = priceInfo;

  const isCurrentTriplePlayProvider =
    provider?.externalId === currentProviderField?.value;

  const isPurchasableProduct =
    purchasableProduct && !isCurrentTriplePlayProvider;
  const isNotPurchasableProduct =
    !purchasableProduct || isCurrentTriplePlayProvider;

  const predicate = customAttributes?.find(
    a => a.description === 'Predicaat',
  );

  return (
    <Div
      position="relative"
      css={{
        background: 'white',
        borderRadius: '16px',
        boxShadow:
          '0px 16px 40px 0px #00000014, 0px 4px 24px 0px #3E486514, 0px 4px 16px 0px #4E5A7E0D',
        height: '100%',
        width: isMobile() ? '100%' : ['300px', '300px', '340px', '372px'],
      }}
    >
      {TopThreeHealthBadgeComponent}

      <Div
        css={{
          padding: '24px',
          outline: data.compare ? '2px solid #004DF5' : '',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          borderRadius: '16px',
          height: '100%',
          boxSizing: 'border-box !important' as any,
        }}
      >
        <Div>
          <Div
            display="flex"
            justifyContent="space-between"
            alignItems={'center'}
          >
            <Div
              maxWidth={'88px'}
              variant={!purchasableProduct ? 'grayedContainer' : ''}
            >
              <ProductLogo image={image} width={'100%'} />
            </Div>

            {predicate?.value && (
              <BluePredicatenIcon/>
            )}

            <Price
              discount={discountIncluded}
              initialValue={priceInitialValue}
              value={data?.priceInfo?.total}
              data={data}
              hidePriceSymbol
              {...data}
            />
          </Div>

          <Checkbox
            mr={'8px'}
            variant="main"
            label="Vergelijk"
            id={`compare-id-${data?.id}`}
            labelPosition="right"
            containerProps={{
              fontFamily: "'Segoe UI', sans-serif",
              alignSelf: 'flex-start',
            }}
            checked={data.compare}
            onChange={() => {
              onCompareChange?.(data.id);
            }}
          />
        </Div>

        <ProductCardMainSection
          data={data}
          productUspsContent={{ data: usps }}
          setCurrentModalTab={(id) => {
            console.log(id);
          }}
          inTopThree
        />

        <InternetAndChannels
          data={data}
          productTypes={productTypes}
          openTab={(id) => {
            console.log(id);
          }}
          containerStyles={{
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
          itemsStyles={{
            speed: {
              order: 0,
            },
            tv: {
              order: 2,
              mt: '0 !important',
            },
            score: {
              order: 1,
              mt: 0,
              // Temporary
              display: 'none',
            },
          }}
        />

        {isPurchasableProduct && (
          <Button
            onClick={()=> {
              handleSubmit();
              sendCustomEvent('top-3-product-click', {
                type: typeMappings[tags[0]]
              });
            }}
            variant="productCardPrimary"
            className="buildButton"
            width="100%"
          >
            Bekijk
          </Button>
        )}

        {isNotPurchasableProduct && (
          <NonPurchasableText
            containerStyles={{
              maxWidth: 'unset !important',
            }}
          />
        )}
      </Div>
    </Div>
  );
};
